<template>
  <div>
    <el-card shadow="never" header="Insurance Information">
      <customize-form
        @change="insuranceInfoChange"
        ref="insuranceInfo"
        :schema="insuranceSchema"
        :model="detailData"
      >
        <div>
          <el-upload
            action=""
            multiple
            :auto-upload="false"
            :limit="15"
            :on-exceed="handleExceed"
            :file-list="CFileList"
            :show-file-list="false"
            :on-change="handleChangeUpload"
          >
            <customize-button>Upload Documents</customize-button>
          </el-upload>
          <ul class="file-list">
            <li
              class="list-item"
              v-for="(item, index) in CFileList"
              :key="index"
              @click="handleDownload(item)"
            >
              {{ item.name }}
              <el-popconfirm
                title="Confirm to delete？"
                confirm-button-text="confirm"
                cancel-button-text="cancel"
                @confirm="handleRemoveItem(item, index)"
              >
                <a href="javascript: void (0)" @click.stop slot="reference">
                  Delete
                </a>
              </el-popconfirm>
            </li>
          </ul>
        </div>
      </customize-form>
    </el-card>
    <div class="btn-wrapper">
      <customize-button style="margin-right: 24px" @click="cancel">
        Cancel
      </customize-button>
      <customize-button type="primary" @click="handleSaveBtn">
        Save
      </customize-button>
    </div>
  </div>
</template>

<script>
import { getInsDetail, addIns, editIns } from './api'
import {
  getCurrencyList,
  commonUpload,
  commonDownload,
  commonRemoveFile,
} from '@/api'
import { ERR_OK } from '@/utils/request'
import dayjs from 'dayjs'
const UPLOAD_READY = 'ready'

export default {
  data() {
    const insuranceSchema = [
      {
        label: 'Insurance Category',
        type: 'select',
        value: 1,
        key: 'insuranceCategory',
        selectList: [
          {
            name: 'Insurance',
            id: 1,
          },
        ],
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Insurance Type',
        type: 'select',
        value: 1,
        key: 'insuranceType',
        change: this.insuranceInfoChange,
        selectList: [
          { name: 'Fully Covered', id: 1 },
          { name: 'Partially Covered', id: 2 },
          { name: 'DCL', id: 3 },
          { name: 'withdraw', id: 4 },
          { name: 'Rejection', id: 5 },
        ],
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Insurance Provider',
        type: 'select',
        value: 1,
        key: 'insuranceProvider',
        selectList: [
          { name: 'Atradius', id: 1 },
          { name: 'Atradius SFL/FOT', id: 2 },
          { name: 'Sinosure', id: 3 },
          { name: 'Mercury/Credendo ', id: 4 },
          { name: 'Coface', id: 5 },
          { name: 'Liberty', id: 7 },
        ],
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Recovery Ratio(%)',
        type: 'input',
        key: 'recoveryRatio',
      },
      {
        label: 'Policy ID',
        type: 'select',
        value: '856610',
        key: 'policyId',
        selectList: [
          { name: '856610', id: '856610' },
          { name: '856609', id: '856609' },
          { name: '825977', id: '825977' },
          { name: '1475413', id: '1475413' },
          { name: '410419', id: '410419' },
          { name: '1445155', id: '1445155' },
          { name: 'LX532136001', id: 'LX532136001' },
          { name: '1126028', id: '1126028' },
          { name: 'SCH009452', id: 'SCH009452' },
          { name: '839030', id: '839030' },
          { name: 'FAC OBLIG COMETA', id: 'FAC OBLIG COMETA' },
          { name: 'FAC OBLIG ESPRINET', id: 'FAC OBLIG ESPRINET' },
          { name: '1048492/TMIM', id: '1048492/TMIM' },
          { name: 'FAC OBLIG -VSTECS ASTAR', id: 'FAC OBLIG -VSTECS ASTAR' },
          { name: 'FAC OBLIG-VST PERICOMP', id: 'FAC OBLIG-VST PERICOMP' },
          { name: 'Qilin AUD - 1017011', id: 'Qilin AUD - 1017011' },
          { name: 'Qilin HKD - 1017015', id: 'Qilin HKD - 1017015' },
          {
            name: 'Qilin IM and TD - 1017017',
            id: 'Qilin IM and TD - 1017017',
          },
          { name: 'Qilin JPY - 1017006', id: 'Qilin JPY - 1017006' },
          { name: 'Qilin NZD - 1017016', id: 'Qilin NZD - 1017016' },
          { name: 'Qilin SF1 - D&H USA', id: 'Qilin SF1 - D&H USA' },
          { name: 'Qilin SF1 - DICKER DATA', id: 'Qilin SF1 - DICKER DATA' },
          { name: 'Qilin SF1 - INGRAM MICRO', id: 'Qilin SF1 - INGRAM MICRO' },
          { name: 'Qilin SF1 - INNOVIX', id: 'Qilin SF1 - INNOVIX' },
          { name: 'Qilin SF1 - INTCOMEX', id: 'Qilin SF1 - INTCOMEX' },
          { name: 'Qilin SGD - 1017013', id: 'Qilin SGD - 1017013' },
          { name: 'Qilin USD - 1017003', id: 'Qilin USD - 1017003' },
          { name: '1007574', id: '1007574' },
          { name: '1351877', id: '1351877' },
          { name: 'LENOVO SFL KRW', id: 'LENOVO SFL KRW' },
        ],
      },
      {
        label: 'Insurance Decision',
        type: 'select',
        value: 1,
        key: 'insuranceDecision',
        selectList: [
          { name: 'Decision 1', id: 1 },
          { name: 'Decision 2', id: 2 },
        ],
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Insurance #',
        type: 'input',
        key: 'insuranceCode',
      },
      {
        label: 'Expiration Date(YYYY-MM-DD)',
        type: 'date',
        key: 'expirationDate',
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Insurance Amount',
        type: 'input',
        key: 'insuranceAmount',
        input: value => this.handleAmountChange(value,'insuranceAmount'),
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'blur' },
        ],
      },
      {
        label: 'Contact Phone',
        type: 'input',
        key: 'contactPhone',
      },
      {
        label: 'Effective Date(YYYY-MM-DD)',
        type: 'date',
        key: 'effectiveDate',
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Currency',
        type: 'select',
        key: 'currency',
        selectList: [],
        rules: [
          { required: true, message: 'Cannot be empty', trigger: 'change' },
        ],
      },
      {
        label: 'Application Amount',
        type: 'input',
        key: 'applicationAmount',
        input: value => this.handleAmountChange(value,'applicationAmount'),
      },
      {
        label: 'Application Date',
        type: 'date',
        key: 'applicationDate',
      },
      {
        label: 'Decision Date',
        type: 'date',
        key: 'decisionDate',
      },
      {
        label: 'Max Payment Term',
        type: 'input',
        key: 'maxPaymentTerm',
        input: value => this.handleAmountChange(value,'maxPaymentTerm'),
      },
      {
        label: 'Allocated Amount',
        type: 'input',
        key: 'relativeWeight',
        input: value => this.handleAmountChange(value,'relativeWeight'),
      },
      {
        label: 'Conversion Date(YYYY-MM-DD)',
        type: 'date',
        key: 'conversionDate',
      },
      {
        label: 'Contact Name',
        type: 'input',
        key: 'contactName',
      },
      {
        label: 'Contact Email',
        type: 'input',
        key: 'contactEmail',
      },
      {
        label: 'Comments',
        type: 'textarea',
        key: 'comments',
      },
      {
        label: 'Condition',
        type: 'textarea',
        key: 'insuranceCondition',
        rules: [
          {
            min: 0,
            max: 6000,
            message: 'No more than 6000 characters.',
            trigger: 'blur',
          },
        ],
      },
    ]
    return {
      isShowInsuranceInformation: false,
      insuranceSchema,
      detailData: {},
      currencyList: [],
      curInsId: this.$route.query.id,
      CFileList: [],
      acceptFileTypes: [
        'png',
        'gif',
        'pjp',
        'jpg',
        'jpeg',
        'bmp',
        'csv',
        'xlsm',
        'xltm',
        'ico',
        'xls',
        'xlsx',
        'doc',
        'docx',
        'pdf',
        'ppt',
        'pptx',
        'txt',
        'rar',
        'zip',
        'html',
        'msg',
      ],
      downloadUrl: '',
    }
  },
  mounted() {
    if (this.curInsId) {
      this._getInsDetail(this.curInsId)
    }
    this._getCurrencyList()
  },
  computed: {
    fileList() {
      return this.detailData?.files || []
    },
  },
  methods: {
    handleDownload(raw) {
      const { id } = raw
      if (!this.downloadUrl && id) {
        commonDownload(id)
      }
    },
    async handleRemoveItem({ id }, index) {
      if (id) {
        await commonRemoveFile(id)
        this.$message.success('success')
      }
      this.CFileList.splice(index, 1)
    },
    handleChangeUpload(file) {
      // 判断文件后缀格式
      const _index = file.name.lastIndexOf('.')
      const _type = file.name.substr(_index + 1)
      if (this.acceptFileTypes.indexOf(_type) === -1) {
        this.$message.error(`.${_type} is invalid`)
        this.CFileList = [...this.CFileList]
        return
      }
      // 单个文件不能超过50M
      const fileSize = Number(file.size / 1024 / 1024)
      if (file.status === UPLOAD_READY && fileSize < 50) {
        this.CFileList.push(file)
      } else {
        this.$message.error('File must not exceed 50M')
        this.CFileList = [...this.CFileList] // 重置列表，如果不重置会出现第五个超出体积再传符合的传不上去
      }
    },
    handleExceed() {
      this.$message.warning(
        'Maximum fifteen files can be uploaded. Each file cannot exceed 50M.',
      )
    },
    async handleAmountChange(value, fieldKey) {
      value = this.$utils.setSeperatenum(value)
      this.insuranceSchema = this.insuranceSchema.map(item => {
        if (item.key === fieldKey) {
          item.value = value
        }
        return item
      })
    },
    /**
     * insuranceInfo数据变化
     */
    insuranceInfoChange(value, form) {
      if (value === 3) {
        form.effectiveDate = dayjs().format('YYYY-MM-DD')
        form.expirationDate = dayjs(new Date(2099, 11, 31)).format('YYYY-MM-DD')
      }
    },
    handleUploadSuccess({ code, msg, data }, file) {
      if (code === ERR_OK) {
        this.attachmentId = data
        this.$message.success(msg)
        this.$set(this.detailData, 'attachmentName', file.name)
      } else {
        this.$message.error(msg)
      }
    },
    async _getCurrencyList() {
      try {
        let currencyList = await getCurrencyList()

        currencyList = currencyList.map(item => ({
          id: item.currency,
          name: item.currencyName,
        }))

        for (let i = 0; i < this.insuranceSchema.length; i++) {
          if (this.insuranceSchema[i].key === 'currency') {
            this.insuranceSchema[i].selectList = currencyList
          }
        }
      } catch (err) {
        console.error(err)
      }
    },
    async _getInsDetail(id) {
      // 根据当前insurance id请求信息
      try {
        const params = {
          id,
        }
        this.detailData = await getInsDetail(params)
      } catch (err) {
        console.log(err)
      }
    },
    async handleUpload() {
      const fileList = this.CFileList

      const resetFileList = fileList.filter(file => !file.id)
      if (!resetFileList.length) {
        return false
      }
      const formData = new FormData()

      resetFileList.forEach(item => {
        formData.append('file', item.raw)
      })
      const { documentId } = this.detailData
      if (documentId) {
        formData.append('id', documentId)
      }
      formData.append('companyId', this.$route.params.customerId)

      return await commonUpload(formData)
    },
    async handleSaveBtn() {
      try {
        const { getFormData, validateFields } = this.$refs.insuranceInfo
        if (await validateFields()) {
          const insuranceInfo = getFormData()
          insuranceInfo.applicationAmount = this.$utils.resetAmount(
            insuranceInfo.applicationAmount,
          )
          insuranceInfo.insuranceAmount = this.$utils.resetAmount(
            insuranceInfo.insuranceAmount,
          )
          insuranceInfo.relativeWeight = this.$utils.resetAmount(
            insuranceInfo.relativeWeight,
          )
          insuranceInfo.maxPaymentTerm = this.$utils.resetAmount(
            insuranceInfo.maxPaymentTerm,
          )
          if (insuranceInfo) {
            const curInsId = this.$route.query.id
            insuranceInfo.companyId = this.$route.params.customerId
            const id = await this.handleUpload()
            if (id) {
              insuranceInfo.attachmentId = id
            }
            if (curInsId) {
              insuranceInfo.id = curInsId
              await editIns(insuranceInfo)
            } else {
              await addIns(insuranceInfo)
            }
            this.$message.success('success')
            this.$router.go(-1)
          }
        }
      } catch (err) {
        console.log(err)
      }
    },
    cancel() {
      this.$router.go(-1)
    },
  },
}
</script>

<style lang="less">
.upload-list {
  display: inline-block;
  width: 200px;
  line-height: 44px;
  font-size: 16px;
  color: #3a3f63;
  margin-left: 20px;
  @include no-wrap();
}
.file-list {
  margin-top: 20px;
  .list-item {
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    line-height: 30px;
    padding: 0 10px;
    border-radius: 8px;

    &:hover {
      background-color: #e2e2e5;
    }
  }
}
.btn-wrapper {
  margin-top: 24px;
  text-align: right;
}
</style>
